import { Component, OnInit, Input, AfterViewInit, Output, EventEmitter } from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: "app-dynamic-message",
  templateUrl: "./dynamicMessage.component.html",
  styleUrls: [
    "./dynamicMessage.component.css"
  ]
})
export class DynamicMessageComponent implements OnInit, AfterViewInit {

  
  userName: string;
  inputMessage: string;
  inputMessage2: string;
  debugMessage: string;

  sendTime: string;
  learningType: string;

  isResponse: boolean = false;
   
  @Output('out') out = new EventEmitter();
  constructor() { }

  ngOnInit() {
  }
  ngAfterViewInit() {
    // console.log(this);
   $('#content').scrollTop( $('#content')[0].scrollHeight);
  }
  outEvent() {
    this.out.emit('outValue');
  }
 
  
}
